// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__PDXpw","canvas":"style_canvas__L9hHj","button":"style_button__jajZl"};